export const ATTRIBUTES = ["炎", "冰", "雷", "光", "暗", "幽", "神", "魔", "无"] as const;

export type Attribute = (typeof ATTRIBUTES)[number];
export type OrdinaryAttribute = Exclude<Attribute, "神" | "魔" | "无">;
export type SoulChainSelection = OrdinaryAttribute | null;

export interface ExpressionField {
  raw: string;
  value: number | null;
  error: string | null;
}

export interface ExpressionResult {
  ok: boolean;
  value: number | null;
  error: string | null;
}

export interface RestraintInput {
  attacker: Attribute;
  defender: Attribute;
  attackSoulChain: SoulChainSelection;
  defenseSoulChain: SoulChainSelection;
  manualExtra: number;
  manualReduction: number;
}

export interface RestraintBreakdown {
  baseModifier: number;
  manualExtra: number;
  attackSoulBonus: number;
  manualReduction: number;
  defenseSoulReduction: number;
  totalModifier: number;
  effectiveMultiplier: number;
  label: string;
  tone: "advantage" | "disadvantage" | "neutral";
}

export interface DamageInputs {
  attack: number;
  defense: number;
  penetration: number;
  skillMultiplier: number;
  aDamageIncrease: number[];
  bDamageIncrease: number[];
  cDamageIncrease: number;
  aDamageReduction: number[];
  bDamageReduction: number[];
  dDamageReduction: number;
  extraCriticalDamage: number;
  criticalDamageReduction: number;
}

export interface DamageResult {
  baseDifference: number;
  nonCritical: number;
  critical: number;
  criticalMultiplier: number;
}

